const SUFFIXES = ['th', 'st', 'nd', 'rd']

export function formatDayWithOriginalIndicatorDateUtil (date = new Date()) {
  const day = date.getDate()
  const relevantSuffix = (day % 10 > 3 || [11, 12, 13].includes(day % 100)) ? 'th' : SUFFIXES[day % 10]
  return `${day}${relevantSuffix}`
}
